import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgButtonIcon2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			stroke: "#FFF",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			d: "M12.5 2v20M2 12.5h20"
		})
	})
});
export default SvgButtonIcon2;
